/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PreLoading from '../../../PreLoading/PreLoading';
import classes from './FavoriteIconButton.module.scss';

interface IFavoriteIconButton {
  favorite: boolean;
  loading?: boolean;
  className?: string;
  clicked: () => void;
}

const FavoriteIconButton: React.FC<IFavoriteIconButton> = ({ favorite, loading = false, className, clicked }) => {
  const renderIcon = () => {
    if (loading) {
      return <div className={classes.spinner} />;
    }

    if (favorite) {
      return (
        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M14.7663 1.2377C14.3753 0.845314 13.9111 0.534045 13.4002 0.321676C12.8893 0.109307 12.3417 0 11.7887 0C11.2357 0 10.6881 0.109307 10.1772 0.321676C9.66629 0.534045 9.20211 0.845314 8.81116 1.2377L7.9998 2.05166L7.18843 1.2377C6.39874 0.445478 5.32768 0.000410637 4.21089 0.000410646C3.09409 0.000410654 2.02303 0.445478 1.23334 1.2377C0.443646 2.02993 8.32078e-09 3.10441 0 4.22479C-8.32078e-09 5.34516 0.443646 6.41965 1.23334 7.21187L2.0447 8.02583L7.9998 14L13.9549 8.02583L14.7663 7.21187C15.1574 6.81967 15.4677 6.354 15.6794 5.84146C15.891 5.32893 16 4.77958 16 4.22479C16 3.67 15.891 3.12064 15.6794 2.60811C15.4677 2.09558 15.1574 1.6299 14.7663 1.2377Z"
            fill="#E9314A"
          />
        </svg>
      );
    }

    return (
      <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.7663 2.2377C15.3753 1.84531 14.9111 1.53404 14.4002 1.32168C13.8893 1.10931 13.3417 1 12.7887 1C12.2357 1 11.6881 1.10931 11.1772 1.32168C10.6663 1.53404 10.2021 1.84531 9.81116 2.2377L8.9998 3.05166L8.18843 2.2377C7.39874 1.44548 6.32768 1.00041 5.21089 1.00041C4.09409 1.00041 3.02303 1.44548 2.23334 2.2377C1.44365 3.02993 1 4.10441 1 5.22479C1 6.34516 1.44365 7.41965 2.23334 8.21187L3.0447 9.02583L8.9998 15L14.9549 9.02583L15.7663 8.21187C16.1574 7.81967 16.4677 7.354 16.6794 6.84146C16.891 6.32893 17 5.77958 17 5.22479C17 4.67 16.891 4.12064 16.6794 3.60811C16.4677 3.09558 16.1574 2.6299 15.7663 2.2377Z"
          stroke="#0B1215"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  return (
    <>
      <div className={`${classes.favoriteIconButton} ${className || ''}`} role="button" tabIndex={0} onClick={clicked} onKeyDown={() => {}}>
        {renderIcon()}
      </div>
    </>
  );
};

export default FavoriteIconButton;
